module.exports = __webpack_public_path__ + "static/media/18.c7aa5252.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shoes/18.png
// module id = 1058
// module chunks = 0